import { render } from "./SectionArtistFull.vue?vue&type=template&id=48b8a1b8&scoped=true"
import script from "./SectionArtistFull.vue?vue&type=script&lang=js"
export * from "./SectionArtistFull.vue?vue&type=script&lang=js"

import "./SectionArtistFull.vue?vue&type=style&index=0&id=48b8a1b8&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b8a1b8"]])

export default __exports__